/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';

function Pagination(props) {
    const {
        totalPage, currentPage, handlePageClick, List, item, search, isSkeleton,
    } = props;

    // Calculate total pages: use List.pagination for Redux-based pages, or totalPage for others
    const totalPages = List?.pagination || totalPage;

    // useEffect(() => {
    // }, [currentPage]);

    return (
        <>
            <style>
                {`
                    [data-testid="paginator"] .react-paginate {
                        display: flex !important;
                        flex-wrap: wrap !important;
                        align-items: center !important;
                        justify-content: center !important;
                        gap: 4px !important;
                        max-width: 100% !important;
                        padding: 28px 0 20px 0 !important;
                        margin: 0 !important;
                    }
                    [data-testid="paginator"] .react-paginate li {
                        list-style: none !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        flex-shrink: 0 !important;
                        margin: 0 !important;
                    }
                    [data-testid="paginator"] .react-paginate .page-link {
                        text-decoration: none !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-width: 28px !important;
                        width: auto !important;
                        max-width: none !important;
                        height: 27px !important;
                        padding: 0 8px !important;
                        white-space: nowrap !important;
                        overflow: visible !important;
                        font-size: 12px !important;
                        font-weight: 400 !important;
                        color: #555259 !important;
                        border: 1px solid transparent !important;
                        border-radius: 5px !important;
                        transition: background-color 0.2s !important;
                        box-sizing: border-box !important;
                    }
                    [data-testid="paginator"] .react-paginate .page-link:hover {
                        background-color: #F2F2F3 !important;
                    }
                    [data-testid="paginator"] .react-paginate .break-link {
                        min-width: auto !important;
                        padding: 0 4px !important;
                    }
                    [data-testid="paginator"] .react-paginate .page-item.selected .page-link,
                    [data-testid="paginator"] .react-paginate .page-item.selected a {
                        background-color: #F2F2F3 !important;
                    }
                    [data-testid="paginator"] .react-paginate a {
                        width: auto !important;
                        max-width: none !important;
                        overflow: visible !important;
                    }
                `}
            </style>
            <div className="flex items-center justify-center flex-wrap" data-testid="paginator" style={{ maxWidth: '100%', overflow: 'visible' }}>
                <ReactPaginate
                    previousLabel={(
                        <button
                            disabled={currentPage === 1}
                            type="button"
                            data-testid="paginator-previous"
                            className="mr-5 bg-[#EBEBEB] rounded-[5px] w-[27px] h-[27px] flex justify-center items-center flex-shrink-0"
                        >
                            {currentPage === 1 ? <img src="/images/chevrons-left.svg" alt="icon" /> : <img src="/images/Right-angle-icon.svg" alt="icon" className="image-rotate" />}

                        </button>
                    )}
                    nextLabel={(
                        <button
                            type="button"
                            data-testid="paginator-next"
                            className="ml-5 bg-[#EBEBEB] rounded-[5px] w-[27px] h-[27px] flex justify-center items-center flex-shrink-0"
                            disabled={currentPage === totalPages}
                        >
                            {currentPage === totalPages ? <img src="/images/chevrons-left.svg" alt="icon" className="image-rotate" /> : <img src="/images/Right-angle-icon.svg" alt="icon" />}
                        </button>
                    )}
                    breakLabel="..."
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    forcePage={currentPage - 1}
                    onPageChange={(val) => {
                        if (isSkeleton) {
                            const payload = Number(val.selected + 1);
                            handlePageClick(payload, List, item, search);
                        } else {
                            handlePageClick(val, List, item, search);
                        }
                    }}
                    containerClassName="react-paginate"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item flex-shrink-0"
                    previousLinkClassName="page-link"
                    nextClassName="page-item flex-shrink-0"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link break-link"
                    activeClassName="selected"
                />
            </div>
        </>
    );
}

export default Pagination;
